export default {
  loading: 'Ładowanie cennika…',
  default_modal: {
    title: 'Domyślny cennik',
    description:
      'Domyślne ceny dziedziczone przez każdego partnera bez własnego nadpisania. Zmiany nie wpływają na aktywne licencje.',
    saved: 'Domyślny cennik zapisany.',
  },
  buttons: {
    edit: 'Edytuj',
    cancel: 'Anuluj',
    save: 'Zapisz',
  },
  toasts: {
    load_error: 'Nie udało się załadować danych cennika.',
    save_error: 'Nie udało się zapisać — spróbuj ponownie.',
    prices_saved: 'Cennik zapisany.',
    license_created: 'Licencja utworzona.',
    lifecycle: {
      pause: 'Licencja wstrzymana.',
      resume: 'Licencja wznowiona.',
      cancel: 'Licencja anulowana.',
    },
  },
  price_book: {
    title: 'Cennik',
    read_only_notice: 'Ceny partnera zastępują główny cennik domyślny. Aktywne licencje zachowują zablokowane ceny.',
    editing_notice: 'Edycja — nowe ceny dotyczą wyłącznie licencji tworzonych od tej chwili.',
    columns: {
      service: 'Usługa',
      cost_price: 'Cena brutto ({{currency}}/miesiąc, z VAT)',
    },
    add_ons: 'Dodatki',
    missing_price: '{{name}} jest włączone, ale nie ma ceny — ustaw cenę lub wyłącz.',
    incomplete_tier:
      '{{name}} wymaga podania zarówno ceny wolumenowej, jak i liczby aktywnych lokalizacji, od której obowiązuje — albo żadnego z tych pól.',
    invalid_tier:
      'Cena wolumenowa dla {{name}} musi być niższa od ceny standardowej, od co najmniej 2 aktywnych lokalizacji.',
    tier: {
      from: 'Cena wolumenowa od',
      live_locations: 'aktywnych lokalizacji',
      counted_one: 'Ten partner ma {{count}} aktywną licencjonowaną lokalizację wliczaną do ceny wolumenowej.',
      counted_few: 'Ten partner ma {{count}} aktywne licencjonowane lokalizacje wliczane do ceny wolumenowej.',
      counted_many: 'Ten partner ma {{count}} aktywnych licencjonowanych lokalizacji wliczanych do ceny wolumenowej.',
      counted_other: 'Ten partner liczy {{count}} aktywnych licencjonowanych lokalizacji do ceny wolumenowej.',
    },
    snapshot_note:
      'Ceny są zablokowane na licencji w momencie jej tworzenia — edycja cennika nie zmienia aktywnych licencji.',
    types: {
      base: 'Podstawowa',
      add_on: 'Dodatek',
    },
  },
  volume_discount: {
    title: 'Rabat wolumenowy',
    read_only_notice:
      'Gdy miesięczna faktura osiągnie próg licencji, rabat jest odliczany od wszystkich opłat licencyjnych tego cyklu.',
    editing_notice: 'Edycja — nowe ustawienia obowiązują od następnego cyklu rozliczeniowego.',
    threshold_label: 'Próg licencji',
    percent_label: 'Rabat',
    invalid: 'Podaj próg co najmniej 1 i rabat od 0 do 100%.',
    saved: 'Rabat wolumenowy zapisany.',
    note: 'Uwzględnia licencje rozliczone w samym cyklu; miesiące przeniesione z poprzednich okresów są wyłączone. 0% (domyślnie) wyłącza rabat — w przeciwnym razie kumulowałby się z ceną wolumenową w cenniku.',
  },
  licenses: {
    test_restaurant_unlicensable: 'Restauracja testowa nigdy nie jest rozliczana, więc nie może posiadać licencji.',
    title: 'Licencje restauracji',
    select_company: 'Wybierz restaurację',
    add_license: 'Dodaj licencję',
    no_companies: 'Ten partner nie ma jeszcze restauracji.',
    no_licenses: 'Brak licencji dla tej restauracji.',
    activated_at: 'Aktywna od',
    next_period_preview: 'Następny miesiąc (proporcjonalnie, przed rabatem wolumenowym)',
    statuses: {
      active: 'Aktywna',
      paused: 'Wstrzymana',
      canceled: 'Anulowana',
    },
    columns: {
      product: 'Usługa',
      locked_price: 'Zablokowana cena / miesiąc',
      quantity: 'Ilość',
      trial_ends: 'Bezpłatnie do',
    },
    price_tiers: {
      volume: 'Stawka wolumenowa',
      locked: 'Cena archiwalna',
    },
  },
  lifecycle: {
    pause: {
      action: 'Wstrzymaj',
      title: 'Wstrzymać tę licencję?',
      description:
        'Wstrzymane dni nie są rozliczane. Licencja zachowuje zablokowane ceny i można ją wznowić w dowolnym momencie.',
      confirm: 'Wstrzymaj',
    },
    resume: {
      action: 'Wznów',
      title: 'Wznowić tę licencję?',
      description: 'Rozliczanie jest wznawiane od dziś według zablokowanych cen.',
      confirm: 'Wznów',
    },
    cancel: {
      action: 'Anuluj licencję',
      title: 'Anulować tę licencję?',
      description:
        'Bieżący miesiąc jest rozliczany proporcjonalnie do dziś. Tej operacji nie można cofnąć — nowa licencja zostałaby utworzona według aktualnych cen cennikowych.',
      confirm: 'Anuluj licencję',
    },
  },
  add_license: {
    title: 'Dodaj licencję',
    description: 'Wybierz usługi dla tej restauracji. Ceny są zablokowane na licencji w momencie tworzenia.',
    per_month: ' / miesiąc',
    create: 'Utwórz licencję',
    no_priced_products: 'Żaden produkt nie ma jeszcze użytecznej ceny dla tego partnera — najpierw ustaw cennik.',
  },
};
